@import (reference) '../constants/spacing.module.less';

.button-with-lock-icon {
  display: flex;
  align-items: center;
  width: fit-content;
}

.icon {
  margin: @space-4 @space-8 0 0;
}
